__turbopack_context__.v({
  "cookie_settings": "CookieSettings-module-scss-module__LzV97q__cookie_settings",
});
